import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MarkdownComponent } from 'ngx-markdown';
import { MarkdownLoaderService } from '../../services/markdown-loader.service';
import { CommonModule } from '@angular/common';
import { DocumentationService } from '../../services/documentation.service';
import { ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
  templateUrl: './documentation.component.html',
  styleUrl: './documentation.component.scss',
  imports: [CommonModule, MarkdownComponent, RouterLink, RouterLinkActive],
})
export class DocumentationComponent implements OnInit, OnDestroy {
  markdownContent = '';
  markdownLoaderService = inject(MarkdownLoaderService);
  documentationService = inject(DocumentationService);
  activatedRoute = inject(ActivatedRoute);
  destroyRef$ = new Subject<void>();

  get tableOfContent() {
    return this.documentationService.documentations;
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe(({ docSlug, chapterSlug, childSlug }) => {
      let filePath = null;

      if (childSlug) {
        filePath = this.documentationService.getChildContent(docSlug, chapterSlug, childSlug);
      } else if (chapterSlug) {
        filePath = this.documentationService.getChapterContent(docSlug, chapterSlug);
      } else if (docSlug) {
        filePath = this.documentationService.getDocContent(docSlug);
      }

      this.markdownLoaderService.getMarkdown(filePath).subscribe((data) => (this.markdownContent = data));
    });
  }

  ngOnDestroy() {
    this.destroyRef$.next();
    this.destroyRef$.unsubscribe();
  }
}
